import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Tab, Table, Tabs } from "react-bootstrap";
import { GiGolfFlag } from "react-icons/gi";
import { MdLeaderboard } from "react-icons/md";
import QdtComponent from "../../components/QdtComponent";
import { useApp } from "../../context/AppContext";
import { fadeIn } from "../../util/animation";
import { qdtComponents } from "../../config/globalApp";
import SelectComponent from "../../SelectComponent";
import {
  Card,
  CenterLogo,
  Divider,
  FieldContainer,
  Label,
  ListContainer,
  RankContainer,
  SpinnerOverlay,
  SpinnerWrapper,
  Value,
} from "./styles";
import { fetchFieldValues } from "../../util/fetchFieldValues";
import { FaList, FaTable } from "react-icons/fa";

export type SelectionOptionsType = {
  label: string;
  value: string;
};

export default function Leaderboard() {
  const {
    goToTop,
    clearAllSelections,
    entrantSelected,
    setEntrantSelected,
    groupTeamCompanySelected,
    setGroupTeamCompanySelected,
    playerSelected,
    setPlayerSelected,
  } = useApp();

  const [viewType, setViewType] = useState("table");
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);

  const [entrants, setEntrants] = useState<SelectionOptionsType[]>([]);
  const [groupTeamCompanyList, setGroupTeamCompanyList] = useState<
    SelectionOptionsType[]
  >([]);
  const [players, setPlayers] = useState<SelectionOptionsType[]>([]);

  const toggleView = () => {
    if (viewType === "list") {
      setViewType("table");
    } else {
      setViewType("list");
    }
  };

  const handleEntrantSelect = async (
    valueSelected: SelectionOptionsType | undefined
  ) => {
    const qApp = await qdtComponents.qAppPromise;
    if (!valueSelected) {
      await qApp?.field("Entrant").clear();
    } else {
      await qApp?.field("Entrant").selectMatch(valueSelected.value);
    }
    setEntrantSelected(valueSelected || undefined);
  };

  const handleGroupTeamCompanySelect = async (
    valueSelected: SelectionOptionsType | undefined
  ) => {
    const qApp = await qdtComponents.qAppPromise;
    if (!valueSelected) {
      await qApp?.field("Group/Team/Company").clear();
    } else {
      await qApp?.field("Group/Team/Company").selectMatch(valueSelected.value);
    }
    setGroupTeamCompanySelected(valueSelected);
  };

  const handlePlayerSelect = async (
    valueSelected: SelectionOptionsType | undefined
  ) => {
    const qApp = await qdtComponents.qAppPromise;
    if (!valueSelected) {
      await qApp?.field("Player").clear();
    } else {
      await qApp?.field("Player").selectMatch(valueSelected.value);
    }
    setPlayerSelected(valueSelected);
  };

  const getEntrantValues = async () => {
    const values = await fetchFieldValues("Entrant");
    setEntrants(values);
  };

  const getGroupTeamCompanyValues = async () => {
    const values = await fetchFieldValues("Group/Team/Company");
    setGroupTeamCompanyList(values);
    //   // let totalRecords = field?.rows.length || 1;
    //   // let total = field?.rowCount || 0;
    //   // while (totalRecords < total) {
    //   //   field?.getMoreData();
    //   //   totalRecords += field?.rows.length || 50;
    //   // }
    //   // if (field?.rows.length === fieldData.rowCount) {
    //   const fieldValues = field?.rows.filter((row: any) => row.qState === "O");
    //   const fieldSelected =
    //     field?.rows.find((row) => row.qState === "S")?.qText || "";
    //   if (fieldSelected) {
    //     setGroupTeamCompanySelected(
    //       fieldSelected
    //         ? {
    //             label: fieldSelected,
    //             value: fieldSelected,
    //           }
    //         : null
    //     );
    //   }
    //   setGroupTeamCompanyList(
    //     fieldValues?.map((row) => ({
    //       label: row.qText,
    //       value: row.qText,
    //     })) || []
    //   );
    //   // }

    //   // fieldData.OnData.unbind();
    // });
  };

  const getPlayerValues = async () => {
    const values = await fetchFieldValues("Player");
    setPlayers(values);
  };

  useEffect(() => {
    async function getValues() {
      setLoadingFilters(true);
      await getEntrantValues();
      await getGroupTeamCompanyValues();
      await getPlayerValues();
      setLoadingFilters(false);
    }
    getValues();
    goToTop();
  }, [goToTop, entrantSelected]);

  const [columns, setColumns] = useState<string[]>([]);
  const [rows, setRows] = useState<any[][]>([]);
  const [masterColumns, setMasterColumns] = useState<string[]>([]);
  const [masterRows, setMasterRows] = useState<any[][]>([]);
  useEffect(() => {
    let qTable: any;

    const fetchTableData = async () => {
      setLoadingTable(true);
      const qApp = await qdtComponents.qAppPromise;
      if (!qApp) return;

      qTable = await qApp.getObject("CXjRMx");
      if (!qTable) return;

      const layout = await qTable.getLayout();
      const hyperCube = layout.qHyperCube;

      if (!hyperCube) {
        console.error("❌ No HyperCube found.");
        return;
      }

      const columnOrder = hyperCube.qColumnOrder || [];

      // ✅ Extract headers
      const headers = [
        ...hyperCube.qDimensionInfo.map((dim: any) => dim.qFallbackTitle),
        ...hyperCube.qMeasureInfo.map((measure: any) => measure.qFallbackTitle),
      ];
      const orderedHeaders = columnOrder.map((index: number) => headers[index]);
      setColumns(orderedHeaders);

      // ✅ Fetch rows dynamically
      const totalRows = hyperCube.qSize.qcy;
      const batch = 1200;
      let fetchedData: any[][] = [];

      for (let qTop = 0; qTop < totalRows; qTop += totalRows) {
        const dataPages = await qTable.getHyperCubeData("/qHyperCubeDef", [
          { qTop, qLeft: 0, qWidth: hyperCube.qSize.qcx, qHeight: batch },
        ]);

        dataPages[0]?.qMatrix?.forEach((row: any) => {
          const formattedRow = row.map((cell: any) => ({
            text: cell.qText,
            state: cell.qState,
            color: cell.qAttrExps?.qValues?.[0]?.qText || "", // Extract RGB color
          }));

          // ✅ Filter only rows where `qState === 'O'`
          // if (formattedRow.some((cell: any) => cell.state === "O")) {
          //   fetchedData.push(formattedRow);
          // }
          fetchedData.push(formattedRow);
        });
      }

      setRows(fetchedData);

      qTable = await qApp.getObject("XMs");
      if (!qTable) return;

      const masterLayout = await qTable.getLayout();
      const masterHyperCube = masterLayout.qHyperCube;

      if (!masterHyperCube) {
        console.error("❌ No HyperCube found.");
        return;
      }

      const masterColumnOrder = masterHyperCube.qColumnOrder || [];

      // ✅ Extract headers
      const masterHeaders = [
        ...masterHyperCube.qDimensionInfo.map((dim: any) => dim.qFallbackTitle),
        ...masterHyperCube.qMeasureInfo.map(
          (measure: any) => measure.qFallbackTitle
        ),
      ];
      const masterOrderedHeaders = masterColumnOrder.map(
        (index: number) => masterHeaders[index]
      );
      setMasterColumns(masterOrderedHeaders);

      // ✅ Fetch rows dynamically
      const masterTotalRows = hyperCube.qSize.qcy;
      let masterFetchedData: any[][] = [];

      for (let qTop = 0; qTop < masterTotalRows; qTop += masterTotalRows) {
        const dataPages = await qTable.getHyperCubeData("/qHyperCubeDef", [
          { qTop, qLeft: 0, qWidth: hyperCube.qSize.qcx, qHeight: batch },
        ]);

        dataPages[0]?.qMatrix?.forEach((row: any) => {
          const formattedRow = row.map((cell: any) => ({
            text: cell.qText,
            state: cell.qState,
            color: cell.qAttrExps?.qValues?.[0]?.qText || "", // Extract RGB color
          }));

          masterFetchedData.push(formattedRow);
        });
      }

      setMasterRows(masterFetchedData);
      setLoadingTable(false);
    };

    fetchTableData();
  }, [entrantSelected, groupTeamCompanySelected, playerSelected]);

  return (
    <motion.div variants={fadeIn} initial="hidden" animate="show">
      <section className="section-space bg-leaderboards-img bg-overlay bg-img-property">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-12">
              <div className="row">
                <MdLeaderboard color={"white"} size={54} />
                <h3 className="text-white text-center pt-2">leaderboards</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mt-lg-3">
        <div className="container">
          <div className="row">
            <div className="card border-success">
              <div className="row card-header bg-sm-transparent bg-success">
                <div className="col-6 text-start">
                  <button
                    onClick={() => {
                      toggleView();
                    }}
                    className="btn btn-warning btn-sm text-dark"
                  >
                    {viewType === "table" ? (
                      <div className="d-flex align-items-center gap-1 text-dark">
                        <FaList size={14} />
                        List
                      </div>
                    ) : (
                      <div className="d-flex align-items-center gap-1">
                        <FaTable size={14} />
                        Table
                      </div>
                    )}
                  </button>
                </div>
                <div className="col-6 text-end">
                  <button
                    onClick={() => clearAllSelections()}
                    className="btn btn-warning btn-sm text-success"
                  >
                    Clear Selections
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row mt-3">
                  <div className="col-lg-4 col-12 mb-2 ">
                    {/* {loadingFilters ? (
                      <div>
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          variant="success"
                        />{" "}
                        Loading Entrants...
                      </div>
                    ) : ( */}
                    <SelectComponent
                      placeholder={
                        loadingFilters ? "Loading..." : "Entrant Filter"
                      }
                      onSelect={handleEntrantSelect}
                      options={entrants}
                      value={entrantSelected}
                      disabled={loadingFilters}
                    />
                    {/* )} */}

                    {/* <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ["Entrant"],
                        placeholder: "Entrant Filter",
                        single: true,
                        showStateInDropdown: true,
                      }}
                    /> */}
                  </div>
                  <div className="col-lg-4 col-12 mb-3">
                    {/* {loadingFilters ? (
                      <div>
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          variant="success"
                        />{" "}
                        Loading Group/Tema/Company...
                      </div>
                    ) : ( */}
                    <SelectComponent
                      placeholder={
                        loadingFilters
                          ? "Loading..."
                          : "Group/Team/Company Filter"
                      }
                      onSelect={handleGroupTeamCompanySelect}
                      options={groupTeamCompanyList}
                      value={groupTeamCompanySelected}
                      disabled={loadingFilters}
                    />
                    {/* )} */}
                    {/* 
                    <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ["Group/Team/Company"],
                        placeholder: "Group/Team/Company Filter",
                        single: true,
                        showStateInDropdown: true,
                      }}
                    /> */}
                  </div>
                  <div className="col-lg-4 col-12 mb-3">
                    {/* {loadingFilters ? (
                      <div>
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          variant="success"
                        />{" "}
                        Loading Players...
                      </div>
                    ) : ( */}
                    <SelectComponent
                      placeholder={
                        loadingFilters ? "Loading..." : "Player Filter"
                      }
                      onSelect={handlePlayerSelect}
                      options={players}
                      value={playerSelected}
                      disabled={loadingFilters}
                    />
                    {/* )} */}

                    {/* <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ["Player"],
                        placeholder: "Player Filter",
                        single: true,
                        showStateInDropdown: true,
                      }}
                    /> */}
                  </div>
                </div>
                <hr />
                <Tabs
                  className="tabs"
                  id="controlled-tab-example"
                  mountOnEnter={true}
                  unmountOnExit={true}
                >
                  <Tab eventKey="mpwtbg" title="MPwtBG">
                    <div>
                      <div
                        className="table-responsive-sm"
                        style={{ overflowX: "auto", maxHeight: "50vh" }}
                      >
                        {loadingTable ? (
                          <div
                            className="d-flex justify-content-center align-items-center w-100"
                            style={{ height: "200px" }}
                          >
                            <SpinnerWrapper>
                              <SpinnerOverlay
                                animation="border"
                                variant="primary"
                              />
                              <CenterLogo
                                src="https://static.wixstatic.com/media/592604_42462c7d665c4b85b750f477a965f020~mv2.png/v1/fill/w_120,h_50,al_c,lg_1,enc_auto/ipc-global-logo_webp.png"
                                alt="200x80x1"
                                className="img-fluid"
                              />
                            </SpinnerWrapper>
                          </div>
                        ) : viewType === "table" ? (
                          <Table striped bordered hover>
                            <thead className="thead-dark">
                              <tr style={{ fontSize: "small" }}>
                                {columns.map((col, idx) => (
                                  <th
                                    style={{
                                      position: "sticky",
                                      top: -1,
                                      backgroundColor: "white",
                                      zIndex: 1000,
                                    }}
                                    key={idx}
                                    className="text-left p-1 border"
                                  >
                                    {col}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map((row, rowIdx) => (
                                <tr key={rowIdx} style={{ fontSize: "small" }}>
                                  {columns.map((header, cellIdx) => {
                                    const cell = row[cellIdx] || {
                                      text: "",
                                      color: "",
                                      state: "",
                                    };
                                    return (
                                      <td
                                        key={cellIdx}
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd",
                                          color: cell.color.startsWith("RGB")
                                            ? cell.color.replace("RGB", "rgb")
                                            : "#000",
                                        }}
                                      >
                                        {cell.text}
                                      </td>
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          <ListContainer>
                            {rows.map((row, rowIdx) => (
                              <Card key={rowIdx}>
                                {/* Rank Section */}
                                <RankContainer>
                                  Rank: {row[0]?.text}
                                </RankContainer>
                                {/* Other Fields in Two Columns */}
                                <FieldContainer>
                                  <Label>{columns[1]}</Label>{" "}
                                  <Value>{row[1]?.text}</Value>
                                </FieldContainer>
                                <Divider />
                                <FieldContainer>
                                  <Label>{columns[2]}</Label>{" "}
                                  <Value color={row[2]?.color}>
                                    {row[2]?.text}
                                  </Value>
                                </FieldContainer>
                                <Divider />
                                <FieldContainer>
                                  <Label>{columns[3]}</Label>{" "}
                                  <Value color={row[3]?.color}>
                                    {row[3]?.text}
                                  </Value>
                                </FieldContainer>
                                <Divider />
                                <FieldContainer>
                                  <Label>{columns[4]}</Label>{" "}
                                  <Value color={row[4]?.color}>
                                    {row[4]?.text}
                                  </Value>
                                </FieldContainer>
                                <Divider />
                                <FieldContainer>
                                  <Label>{columns[5]}</Label>{" "}
                                  <Value>{row[5]?.text}</Value>
                                </FieldContainer>
                              </Card>
                            ))}
                          </ListContainer>
                        )}
                      </div>
                    </div>

                    {/* <QdtComponent
                      type="QdtViz"
                      props={{
                        id: "CXjRMx",
                        height: "60vh",
                      }}
                    /> */}
                  </Tab>
                  <Tab
                    eventKey="masters"
                    title="Masters"
                    className="text-success"
                  >
                    <React.Suspense fallback={() => <div>Loading...</div>}>
                      {loadingTable ? (
                        <div
                          className="d-flex justify-content-center align-items-center w-100"
                          style={{ height: "200px" }}
                        >
                          <SpinnerWrapper>
                            <SpinnerOverlay
                              animation="border"
                              variant="primary"
                            />
                            <CenterLogo
                              src="https://static.wixstatic.com/media/592604_42462c7d665c4b85b750f477a965f020~mv2.png/v1/fill/w_120,h_50,al_c,lg_1,enc_auto/ipc-global-logo_webp.png"
                              alt="200x80x1"
                              className="img-fluid"
                            />
                          </SpinnerWrapper>
                        </div>
                      ) : (
                        <div
                          className="table-responsive-sm"
                          style={{ overflowX: "auto", maxHeight: "50vh" }}
                        >
                          <Table striped bordered hover>
                            <thead className="thead-dark">
                              <tr style={{ fontSize: "small" }}>
                                {masterColumns.map((col, idx) => (
                                  <th
                                    style={{
                                      position: "sticky",
                                      top: -1,
                                      backgroundColor: "white",
                                      zIndex: 1000,
                                    }}
                                    key={idx}
                                    className="text-left p-1 border"
                                  >
                                    {col}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {masterRows.map((row, rowIdx) => (
                                <tr key={rowIdx} style={{ fontSize: "small" }}>
                                  {masterColumns.map((header, cellIdx) => {
                                    const cell = row[cellIdx] || {
                                      text: "",
                                      color: "",
                                      state: "",
                                    };
                                    return (
                                      <td
                                        key={cellIdx}
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd",
                                          color:
                                            cell.color.startsWith("RGB") &&
                                            cell.color !== "RGB(255,255,255)" &&
                                            cell.color !== "RGB(210,210,210)"
                                              ? cell.color.replace("RGB", "rgb")
                                              : "#000",
                                        }}
                                      >
                                        {cell.text}
                                      </td>
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                      {/* 
                      <QdtComponent
                        type="QdtViz"
                        props={{
                          type: "table",
                          id: "XMs",
                          height: "60vh",
                        }}
                      /> */}
                    </React.Suspense>
                  </Tab>
                </Tabs>
              </div>
              <div className="card-footer bg-transparent">
                <div className="row">
                  <div className="col">
                    <GiGolfFlag color="green" size={32} />
                  </div>
                  <div className="col text-end">
                    <React.Suspense fallback={() => <div>Loading...</div>}>
                      <QdtComponent
                        type="QdtViz"
                        props={{
                          id: "aKkDx",
                          height: "45px",
                        }}
                      />
                    </React.Suspense>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
